document.addEventListener("DOMContentLoaded", function () {
  window.upcartOnCartLoaded = function (cart) {
    if (!cart) return;
    const rewardWrapper = document.querySelector(".upcart-rewards");
    if (cart.item_count == 0) {
      const customEmptyCart = document.querySelector("[data-empty-cart]");
      const customEmptyCartWrapper = document.querySelector(
        '#upCart div[class^="styles_CartPreview__empty"]'
      );
      if (rewardWrapper) {
        rewardWrapper.style.display = "none";
      }
      if (!customEmptyCart || !customEmptyCartWrapper) return;
      customEmptyCartWrapper.innerHTML = customEmptyCart.innerHTML;
    } else {
      const cartBottom = document.querySelector(".td-cart-custom-bottom");
      const customCart = document.querySelector("[data-custom-upcart]");
      if (cartBottom && customCart) {
        const freeShippingThreshold = customCart.dataset.fsThreshold;
        const shippingMessage =
          cart.total_price > freeShippingThreshold
            ? customCart.dataset.fsThresholdPassed
            : customCart.dataset.fsThresholdPending;
        cartBottom.innerHTML = `<div class="td-cart-custom-bottom__row"><h6>Subtotal</h6><p>${window.Shopify.formatMoney(
          cart.total_price,
          $("body").data("money-format")
        )}</p></div><div class="td-cart-custom-bottom__row"><h6>Shipping</h6><p>${shippingMessage}</p></div>`;
      }
      if (rewardWrapper) {
        rewardWrapper.style.display = "block";
      }
    }
  };
});
